import { createEntityAdapter } from '@reduxjs/toolkit';
import { TestResponsePrivate } from '@tests/types';

export const testsAdapter = createEntityAdapter<TestResponsePrivate<string>>();
